import { ClipboardList, Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { sectionStatusConfig, type SectionStatus } from '../utils/checklistStatus';

interface ChecklistCardProps {
  checklist: {
    id: string;
    nome: string;
    descricao: string | null;
    comissaoNome?: string;
  };
  sectionStatuses?: Array<{ nome: string; status: SectionStatus }>;
  onEdit: () => void;
  onDelete: () => void;
  onFill?: () => void;
  canEdit?: boolean;
}

export function ChecklistCard({ checklist, sectionStatuses, onEdit, onDelete, onFill, canEdit = true }: ChecklistCardProps) {
  return (
    <div className="rounded-lg border border-gray-200 border-l-4 border-l-primary-500 bg-white p-5 shadow-sm">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <ClipboardList className="h-5 w-5 text-gray-400" />
          <h3 className="text-lg font-semibold text-gray-900">{checklist.nome}</h3>
        </div>
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="sm" onClick={onEdit} title="Editar" disabled={!canEdit} className={!canEdit ? 'opacity-50 cursor-not-allowed' : ''}>
            <Pencil className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="sm" onClick={onDelete} title="Excluir" disabled={!canEdit} className={!canEdit ? 'opacity-50 cursor-not-allowed' : ''}>
            <Trash2 className="h-4 w-4 text-red-500" />
          </Button>
        </div>
      </div>

      {checklist.descricao && (
        <p className="text-sm text-gray-500 mb-3 line-clamp-2">{checklist.descricao}</p>
      )}

      {sectionStatuses && sectionStatuses.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-3">
          {sectionStatuses.map((s) => {
            const cfg = sectionStatusConfig[s.status];
            return (
              <span
                key={s.nome}
                className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs ${cfg.bg} ${cfg.text}`}
                title={s.nome}
              >
                {s.nome}: {cfg.label}
              </span>
            );
          })}
        </div>
      )}

      <div className="flex items-center justify-between">
        {checklist.comissaoNome && (
          <span className="inline-flex rounded-full px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-800">
            {checklist.comissaoNome}
          </span>
        )}
        {onFill && (
          <Button variant="outline" size="sm" onClick={onFill}>
            Preencher
          </Button>
        )}
      </div>
    </div>
  );
}
